export default __webpack_public_path__ + "static/img18h-dfcdae8f6b748e7e8384b6f147676f65.jpg";